import hnbBannerImage from 'assets/img/hnb-approved-banner.png'
import hnbLogo from 'assets/img/hnb-octane-logo.svg'
import hnbLogoImage from 'assets/img/lenders/HuntingtonNationalBank.svg'
import rrLogoImage from 'assets/img/lenders/RoadrunnerFinancial.svg'
import LenderName from 'state/enums/LenderName'

import { BrandConfig, CustomTheme } from './types'

type LenderOptions = Partial<Record<string | LenderName, string>>

export const navBarLogos: LenderOptions = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: hnbLogo,
}

export const brandConfig: Partial<Record<LenderName, Partial<BrandConfig>>> = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: {
        sparkThemeConfig: {
            primary: '#002d2a',
        } as CustomTheme,
    },
}

export const contractNames: LenderOptions = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: 'Huntington National Bank',
    [LenderName.ROADRUNNER_FINANCIAL]: 'Roadrunner Financial Contract',
}

export const dealTableLogos: LenderOptions = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: hnbLogoImage,
    [LenderName.ROADRUNNER_FINANCIAL]: rrLogoImage,
}

export const decisionResultBanners: LenderOptions = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: hnbBannerImage,
}

export const eligibilityClaimsLogos: LenderOptions = {
    [LenderName.HUNTINGTON_NATIONAL_BANK]: hnbLogoImage,
}
